import React from "react"
import { ExampleArrow } from "@components/resources/example-grid"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { isExternal } from "@utils/is-external"
import { cssConfig } from "@utils/css-validator"
import { isSameTab } from "@utils/is-same-tab"

const StyleProps = css`
  cursor: ${({ link, onClick }) => (link || onClick) && "pointer"};
  color: ${props => props.color ?? props.theme.color.blue400};
  font-size: ${props => props.fontSize ?? "inherit"};
  font-weight: 700;
  transition: filter 0.3s ease-in-out, color 0.3s ease-in-out;
  margin: ${props => props.margin ?? "0"};
  line-height: ${props => props.lineHeight};

  ${ExampleArrow} {
    color: ${props => props.color ?? props.theme.color.blue400};
    font-weight: 700;
    margin-left: 12px;
    transition: margin 0.3s ease-in-out, color 0.3s ease-in-out;
  }

  &:hover {
    ${props =>
      props.hover
        ? css`
            color: ${props.hover};
          `
        : css`
            filter: brightness(70%);
          `}
    ${ExampleArrow} {
      color: ${props => props.hover ?? "inherit"};
      margin-left: 20px;
    }
  }
`

const StyledGatsbyLink = styled(Link).withConfig(cssConfig)`
  ${StyleProps}
`

const StyledLink = styled.a.withConfig(cssConfig)`
  ${StyleProps}
`

const Anchor = ({ link, arrow, children, onClick, ...rest }) => {
  const external = isExternal(link)
  const sameTab = isSameTab(link)

  if (onClick) {
    return (
      <StyledLink onClick={onClick} {...rest}>
        {children}
        {arrow && <ExampleArrow />}
      </StyledLink>
    )
  } else {
    return external ? (
      <StyledLink target={sameTab ? "_self" : "_blank"} href={link} {...rest}>
        {children}
        {arrow && <ExampleArrow />}
      </StyledLink>
    ) : (
      <StyledGatsbyLink to={link} {...rest}>
        {children}
        {arrow && <ExampleArrow />}
      </StyledGatsbyLink>
    )
  }
}

Anchor.propTypes = {
  link: PropTypes.string,
  arrow: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  hover: PropTypes.string,
  fontSize: PropTypes.string,
  margin: PropTypes.string,
  onClick: PropTypes.func,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Anchor
